module.exports = "/_next/static/images/elf_yellow-6f707156afa9b789703ffce366b58c81.png";